<div class="w-100 text-center cursor" #mapContainer>
    <img class="w-100" [src]="url" #mapImg />
</div>
